import api from '@/api';
import config from '@/api/config';
import {parseJwt} from '@/helpers/helpers'

export default {
    namespaced: true,

    state: {
        newSiteId: null,
    },

    getters: {},

    mutations: {},

    actions: {

        async deleteSitePhoto(context, {uid_site}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites/${uid_site}/photo`;
            try {
                const response = await api.request("delete", url);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async changeSitePhoto(context, {uid_site, file}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites/${uid_site}/photo`;
            let formData = new FormData();
            formData.append('place_img', file);

            try {
                const response = await api.request("post", url, formData);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async setMultipleSitesMode(context) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/setMultipleSitesMode`;
            try {
                const response = await api.request("put", url);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async addQuestionToSite(context, {body, site_uid}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites/${site_uid}/questions`;
            try {
                const response = await api.request("post", url, body);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async removeManager(context, {placeID, uid}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = placeID ? `/admin/organizations/${guid}/places/${placeID}/admins/${uid}` : `/admin/organizations/${guid}/admins/${uid}`;
            try {
                const responce = await api.request('delete', url);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async cancelInvite(context, {placeID, uid}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = placeID ? `/admin/organizations/${guid}/places/${placeID}/invites/${uid}` : `/admin/organizations/${guid}/invites/${uid}`;
            try {
                const responce = await api.request('delete', url);
                return responce.data
            } catch (error) {
                throw error;
            }
        },

        async sendInvite(context, {placeID, body, orgUid}) {
            const guid = orgUid || context.rootGetters['auth/getOrgUid']
            const url = placeID ? `/admin/organizations/${guid}/places/${placeID}/invites` : `/admin/organizations/${guid}/invites`;
            const responce = await api.request('post', url, body);
            return responce.data
        },

        async getManagers(context, {placeID}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = placeID ? `/admin/organizations/${guid}/places/${placeID}/admins` : `/admin/organizations/${guid}/admins`;
            try {
                const response = await api.request('get', url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
        async openFileReport(context, {dateFromLocal, dateToLocal, placeUids, type, dataType = 'full'}) {
            const guid = context.rootGetters['auth/getOrgUid']
            let url = `${config.baseUrl}/admin/organizations/${guid}/managerReport/${type}?data_type=${dataType}`
            if (dateFromLocal) {
                url += `&date_from_local=${encodeURIComponent(dateFromLocal)}`
            }
            if (dateToLocal) {
                url += `&date_to_local=${encodeURIComponent(dateToLocal)}`
            }
            if (placeUids && placeUids.length != 0) {
                for (let i = 0; placeUids.length > i; i++) {
                    url += `&place_uids[]=${placeUids[i]}`
                }
            }

            if (!localStorage.getItem('ssid')) { //todo remove hack backward compatability
                localStorage.setItem('ssid', parseJwt(localStorage.getItem('access_token')).ssid)
            }

            url += `&ssid=${localStorage.getItem('ssid')}`
            console.log(url)
            window.open(url, '_blank').focus()
        },

        async fetchOrganizations(context, obj) {
            const url = `/admin/organizations?page=${obj.page}`;
            try {
                const response = await api.request('get', url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async fetchQuestionsByOrganization(context, {organizationGuid}) {
            const guid = organizationGuid || context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/questions?limit=10000`;
            const response = await api.request('get', url);
            return response.data;
        },

        async addOwnerToOrganization(context, {organizationID, userID}) {
            const url = `/admin/organizations/${organizationID}/user`;
            const body = {
                user_id: userID
            }
            try {
                const response = await api.request('post', url, body);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async addPlaceToOrganization(context, {organizationID, placeID}) {
            const url = `/admin/organizations/${organizationID}/place`;
            const body = {
                place_id: placeID
            }
            try {
                const response = await api.request('post', url, body);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async removePlaceFromOrganization(context, {organizationID, placeID}) {
            const url = `/admin/organizations/${organizationID}/place`;
            const body = {
                place_id: placeID
            }

            const response = await api.request('delete', url, body);
            return response.data
        },

        async removeOwnerFromOrganization(context, {organizationID, userID}) {
            const url = `/admin/organizations/${organizationID}/owner`;
            const body = {
                user_id: userID
            }
            const response = await api.request('delete', url, body);
            return response.data
        },

        async deleteOrganization(context, orgGuid = null) {
            const guid = orgGuid || context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}`;
            return await api.request('delete', url);
        },

        async upadteOrganization(context, {organizationID, organization}) {
            const url = `/admin/organizations/${organizationID}`;
            return await api.request('put', url, organization);
        },
        async checkReport(context, obj) {
            const data = obj
            const guid = context.rootGetters['auth/getOrgUid']
            let url = `/admin/organizations/${guid}/managerReport/status?`
            url += `ssid=${localStorage.getItem('ssid')}`
            return (await api.request("post", url, data)).data
        },
        async getReportOnMobile(context, {dateFromLocal, dateToLocal, placeUids, dataType = 'full'}) {
            const guid = context.rootGetters['auth/getOrgUid']
            let url = `${config.baseUrl}/admin/organizations/${guid}/managerReport/mobile/xlsx?data_type=${dataType}`
            if (dateFromLocal) {
                url += `&date_from_local=${dateFromLocal}`
            }
            if (dateToLocal) {
                url += `&date_to_local=${dateToLocal}`
            }
            if (placeUids && placeUids.length != 0) {
                for (let i = 0; placeUids.length > i; i++) {
                    url += `&place_uids[]=${placeUids[i]}`
                }
            }
            url += `&ssid=${localStorage.getItem('ssid')}`
            window.open(`${url}`, '_blank').focus()
        },
    },
};
